'use strict';
require('./google-analytics');

require('./BrowserDetect');

require('./bloodhound_intercept');

require('./pop_affiliate_script');

require('./app');

require('../../modules/coupons/frontend/coupons');

require('../../modules/coupons/frontend/share');

require('../../modules/stores/frontend/stores');

require('../../modules/search/frontend/search');

Modules.Occasions.Application = require('../../modules/occasions/frontend/application');

Modules.Categories.Application = require('../../modules/categories/frontend/application');

require('./coupons-carousel');

window.ZeroClipboard = require('./vendor_modules/ZeroClipboard.js');

require('./BrowserConditionals');

require('./ModernizrTests');

require('../../modules/groupon-iframe-login/frontend/iframe_login');

require('../../modules/shared/frontend/helpers/iframe_login_override');

require('../../modules/shared/frontend/vue/init-vue-components');

require('../../modules/shared/frontend/helpers/fix_a11y');

$(document).ready(function() {
  $('body').removeClass('no-js');
  $.ajaxSetup({
    cache: false
  });
  new Modules.Occasions.Application();
  return new Modules.Categories.Application();
});

